import React, { useState } from 'react'
import BrokerEmailsModal from './BrokerEmailsModal'
import useGlobalTheme from '../../../hooks/useGlobalTheme'

function TopBrokerages({ brokerages, timePeriod, selectedAccount }) {
	const [selectedBroker, setSelectedBroker] = useState(null)
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	const cardCls = isLight
		? 'bg-white rounded-2xl p-6 border border-gray-200 shadow-sm'
		: 'bg-gray-800 rounded-2xl p-6 border border-gray-700'
	const titleCls = isLight ? 'text-gray-900 text-xl font-semibold mb-6' : 'text-white text-xl font-semibold mb-6'
	const emptyCls = isLight ? 'text-gray-500' : 'text-gray-400'
	const headerRowCls = isLight ? 'border-b border-gray-200' : 'border-b border-gray-700'
	const headerCellCls = isLight ? 'text-gray-500 font-medium' : 'text-gray-400 font-medium'
	const bodyRowBorder = isLight ? 'border-b border-gray-200' : 'border-b border-gray-700'
	const rowHover = isLight ? 'hover:bg-gray-50' : 'hover:bg-gray-700/50'
	const rowAltBg = isLight
		? (i => (i % 2 === 0 ? 'bg-gray-50/60' : 'bg-white'))
		: (i => (i % 2 === 0 ? 'bg-gray-800/50' : 'bg-gray-800'))
	const primaryCell = isLight ? 'text-gray-900 font-medium' : 'text-white font-medium'
	const secondaryCell = isLight ? 'text-gray-700' : 'text-gray-300'

	if (!brokerages || brokerages.length === 0) {
		return (
			<div className={cardCls}>
				<h3 className={titleCls}>Top brokerages</h3>
				<p className={emptyCls}>No brokerage data available</p>
			</div>
		)
	}

	return (
		<div className={cardCls}>
			<h3 className={titleCls}>Top brokerages</h3>

			<div className="overflow-x-auto overscroll-x-contain">
				<table className="w-full">
					<thead>
						<tr className={headerRowCls}>
							<th className={`text-left py-3 px-4 ${headerCellCls}`}>
								Brokerage
							</th>
							<th className={`text-left py-3 px-4 ${headerCellCls}`}>
								MC#
							</th>
							<th className={`text-center py-3 px-4 ${headerCellCls}`}>
								Emails Sent
							</th>
							<th className={`text-left py-3 px-4 ${headerCellCls}`}>
								Domains
							</th>
							<th className={`text-center py-3 px-4 ${headerCellCls}`}>
								Recipients
							</th>
						</tr>
					</thead>
					<tbody>
						{brokerages.map((brokerage, index) => (
							<tr
								key={brokerage.mcNumber}
								onClick={() => setSelectedBroker(brokerage)}
								className={`${bodyRowBorder} ${rowHover} transition-colors cursor-pointer ${rowAltBg(index)}`}
							>
								<td className={`py-4 px-4 ${primaryCell}`}>
									{brokerage.name}
								</td>
								<td className={`py-4 px-4 ${secondaryCell}`}>{brokerage.mcNumber}</td>
								<td className={`py-4 px-4 text-center ${secondaryCell}`}>{brokerage.emailsSent}</td>
								<td className={`py-4 px-4 ${secondaryCell}`}>{brokerage.domains}</td>
								<td className={`py-4 px-4 text-center ${secondaryCell}`}>{brokerage.uniqueRecipients}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<BrokerEmailsModal
				isOpen={!!selectedBroker}
				onClose={() => setSelectedBroker(null)}
				broker={selectedBroker}
				timePeriod={timePeriod}
				selectedAccount={selectedAccount}
			/>
		</div>
	)
}

export default TopBrokerages
